export default "__VITE_ASSET__D9reNezH__ 584w";